import AppStore from "./AppStore";
import NeoSatApiClient from "./client/NeoSatApiClient";
import { configureMobX } from "./config/mobx.config";

export class RootStore {
    public readonly appStore: AppStore;
    public readonly apiClient: NeoSatApiClient;

    constructor(apiClient?: NeoSatApiClient) {
        configureMobX();
        this.apiClient = apiClient ?? new NeoSatApiClient("");
        this.appStore = new AppStore(this);
    }

    public async initialize(): Promise<void> {
        await this.appStore.start();
    }

    public dispose(): void {
        this.appStore.dispose();
    }
}

export function createRootStore(apiClient?: NeoSatApiClient): RootStore {
    return new RootStore(apiClient);
}

